import type { ExtractionAssignmentOut } from '@/api'

export type AssigneeFilter = 'all' | 'mine' | 'unassigned'

export interface ExtractionsQuery {
  search: string
  sort: string
  review: 'all' | 'needs_review' | 'complete'
  assignee: AssigneeFilter
  assigneeIds?: string[]
  includeUnassigned?: boolean
  page: number
  pageSize: number
}

export type NativeExtractionQueueRow = ExtractionPresentation & {
  assignment: ExtractionAssignmentOut
  lifecycle_version: number
}

export type TreeKind = 'assay' | 'channel'

export type ExtractionStatus = 'queued' | 'running' | 'success' | 'partial' | 'cancelled' | 'failed'
export type ExtractionReviewState =
  | 'not_available'
  | 'empty'
  | 'not_started'
  | 'in_progress'
  | 'complete'

export interface ExtractionPresentationArtifact {
  file_id: string
  file_url: string
  source_file_path: string
  marked_done: boolean
}

export interface ExtractionPresentation {
  id: string
  project_id: number
  source_file_paths: string[]
  source_commit_sha: string
  name: string
  status: ExtractionStatus
  artifacts: ExtractionPresentationArtifact[]
  extractor_format?: string | null
  tree_kind: TreeKind
  origin: string
  import_commit_sha?: string | null
  started_at?: string | null
  completed_at: string
  created_at: string
  review_total_count: number
  review_marked_done_count: number
  review_state: ExtractionReviewState
}

export const DEFAULT_TREE_KIND: TreeKind = 'assay'

export const DEFAULT_EXTRACTIONS_QUERY: ExtractionsQuery = {
  search: '',
  sort: '-created_at',
  review: 'all',
  assignee: 'all',
  page: 1,
  pageSize: 20,
}
